import { createApp } from 'vue'
import GameTab from '../../components/user_sale_games/game-tab.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(GameTab)
  app.mount('#game-tab')
})